import { render, staticRenderFns } from "./SlotMachineDp.vue?vue&type=template&id=8b1ee75c"
import script from "./SlotMachineDp.vue?vue&type=script&lang=js"
export * from "./SlotMachineDp.vue?vue&type=script&lang=js"
import style0 from "./SlotMachineDp.vue?vue&type=style&index=0&id=8b1ee75c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
